/**
 * LES COULEURS DE STATUT, TRADUITES DANS CELLES DE LA MAQUETTE.
 *
 * La base range une couleur par statut — `emerald`, `amber`, `orange`… — et la
 * maquette n'en connaît que six : `green`, `tan`, `blue`, `violet`, `pink`,
 * `terra`. C'est une table de correspondance PUREMENT visuelle : aucun statut
 * ne change de nom, de sens ni de valeur, on ne fait que dire de quelle encre
 * la maquette peint celui qui existe déjà.
 */
const MAP: Record<string, string> = {
  emerald: 'green',
  green: 'green',
  amber: 'tan',
  tan: 'tan',
  orange: 'terra',
  terra: 'terra',
  rose: 'pink',
  pink: 'pink',
  blue: 'blue',
  sky: 'blue',
  violet: 'violet',
  purple: 'violet',
};

/** La classe de pastille de la maquette pour une couleur de statut du portail. */
export function pillOf(color?: string | null): string {
  return MAP[(color || '').toLowerCase()] || '';
}
